'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeProductForm = require('@shopify/theme-product-form');

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _themeA11y = require('@shopify/theme-a11y');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

var classes = {
  hide: 'hide'
};

var keyboardKeys = {
  ENTER: 13
};

var selectors = {
  submitButton: '[data-submit-button]',
  submitButtonText: '[data-submit-button-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  priceWrapper: '[data-price-wrapper]',
  imageWrapper: '[data-product-image-wrapper]',
  visibleImageWrapper: '[data-product-image-wrapper]:not(.' + classes.hide + ')',
  imageWrapperById: function imageWrapperById(id) {
    return selectors.imageWrapper + '[data-image-id=\'' + id + '\']';
  },
  productForm: '[data-product-form]',
  productPrice: '[data-product-price]',
  thumbnail: '[data-product-single-thumbnail]',
  thumbnailById: function thumbnailById(id) {
    return '[data-thumbnail-id=\'' + id + '\']';
  },
  thumbnailActive: '[data-product-single-thumbnail][aria-current]'
};

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var productFormElement, variants, main_obj, thumbs_slider;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              productFormElement = document.querySelector(selectors.productForm);
              _context.next = 3;
              return _this.getProductJson(productFormElement.dataset.productHandle);

            case 3:
              _this.product = _context.sent;


              _this.productForm = new _themeProductForm.ProductForm(productFormElement, _this.product, {
                onOptionChange: _this.onFormOptionChange.bind(_this)
              });

              variants = _this.product.variants;
              main_obj = _this;

              //    this.onThumbnailClick = this.onThumbnailClick.bind(this);
              //    this.onThumbnailKeyup = this.onThumbnailKeyup.bind(this);
              //
              //    this.container.addEventListener('click', this.onThumbnailClick);
              //    this.container.addEventListener('keyup', this.onThumbnailKeyup);

              $('.page-product__images-item').zoom();

              $('.page-product__images-items').slick({
                fade: true,
                arrows: false,
                focusOnSelect: true,
                asNavFor: '.page-product__images-thumbs'
              });
              thumbs_slider = $('.page-product__images-thumbs');

              thumbs_slider.slick({
                arrows: true,
                asNavFor: '.page-product__images-items',
                focusOnSelect: true,
                mobileFirst: true,
                vertical: false,
                variableWidth: true,
                responsive: [{
                  breakpoint: 768,
                  settings: {
                    variableWidth: false,
                    vertical: true,
                    verticalSwiping: true,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                }]
                //centerMode: true
              });

              thumbs_slider.on('wheel', function (e) {
                e.preventDefault();

                if (e.originalEvent.deltaY < 0) {
                  $(this).slick('slickNext');
                } else {
                  $(this).slick('slickPrev');
                }
              });

              $.fn.init_quantity = function () {
                $(this).each(function () {
                  var $quantity = $(this);
                  var $minus = $quantity.find('.minus');
                  var $input = $quantity.find('input');
                  var $plus = $quantity.find('.plus');

                  $minus.on('click', function () {
                    var current_val = parseInt($input.val());
                    if (current_val >= 2) {
                      $input.val(current_val - 1);
                    }
                  });
                  $plus.on('click', function () {
                    var current_val = parseInt($input.val());
                    $input.val(current_val + 1);
                  });
                });
              };
              $('.page-product__quantity-input').init_quantity();

              $('.product-instagram__items').slick({
                //fade: true,
                arrows: true,
                mobileFirst: true,
                variableWidth: true,
                appendArrows: '.product-instagram__items-nav',
                responsive: [{
                  breakpoint: 768,
                  settings: {}
                }]
              });

              jQuery('.swatch :radio').change(function () {

                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                var optionValue = jQuery(this).val();
                jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');

                var index = jQuery('.swatch :radio').index(this);
                var variant_obj = variants[index];

                main_obj.renderImages(variant_obj);
                main_obj.renderPrice(variant_obj);
                main_obj.renderComparePrice(variant_obj);
                main_obj.renderSubmitButton(variant_obj);
                main_obj.updateBrowserHistory(variant_obj);
              }).filter(':first').trigger('change');

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  onUnload: function onUnload() {
    this.productForm.destroy();
    this.removeEventListener('click', this.onThumbnailClick);
    this.removeEventListener('keyup', this.onThumbnailKeyup);
  },
  getProductJson: function getProductJson(handle) {
    return fetch('/products/' + handle + '.js').then(function (response) {
      return response.json();
    });
  },
  onFormOptionChange: function onFormOptionChange(event) {
    console.log('event change');
    var variant = event.dataset.variant;

    this.renderImages(variant);
    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);

    this.updateBrowserHistory(variant);
  },
  onThumbnailClick: function onThumbnailClick(event) {
    var thumbnail = event.target.closest(selectors.thumbnail);

    if (!thumbnail) {
      return;
    }

    event.preventDefault();

    this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },
  onThumbnailKeyup: function onThumbnailKeyup(event) {
    if (event.keyCode !== keyboardKeys.ENTER || !event.target.closest(selectors.thumbnail)) {
      return;
    }

    var visibleFeaturedImageWrapper = this.container.querySelector(selectors.visibleImageWrapper);

    (0, _themeA11y.forceFocus)(visibleFeaturedImageWrapper);
  },
  renderSubmitButton: function renderSubmitButton(variant) {
    var submitButton = this.container.querySelector(selectors.submitButton);
    var submitButtonText = this.container.querySelector(selectors.submitButtonText);

    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = 'Add to bag';
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
    }
  },
  renderImages: function renderImages(variant) {
    if (!variant || variant.featured_image === null) {
      return;
    }
    $('.page-product__images-items').slick('slickGoTo', variant.featured_image.position - 1);
    console.log(variant.featured_image);

    //this.renderFeaturedImage(variant.featured_image.id);
    //this.renderActiveThumbnail(variant.featured_image.id);
  },
  renderPrice: function renderPrice(variant) {
    var priceElement = this.container.querySelector(selectors.productPrice);
    var priceWrapperElement = this.container.querySelector(selectors.priceWrapper);

    priceWrapperElement.classList.toggle(classes.hide, !variant);

    if (variant) {
      priceElement.innerText = (0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat);
    }
  },
  renderComparePrice: function renderComparePrice(variant) {
    if (!variant) {
      return;
    }

    var comparePriceElement = this.container.querySelector(selectors.comparePrice);
    var compareTextElement = this.container.querySelector(selectors.comparePriceText);

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    if (variant.compare_at_price > variant.price) {
      comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = '';
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },
  renderActiveThumbnail: function renderActiveThumbnail(id) {
    var activeThumbnail = this.container.querySelector(selectors.thumbnailById(id));
    var inactiveThumbnail = this.container.querySelector(selectors.thumbnailActive);

    if (activeThumbnail === inactiveThumbnail) {
      return;
    }

    inactiveThumbnail.removeAttribute('aria-current');
    activeThumbnail.setAttribute('aria-current', true);
  },
  renderFeaturedImage: function renderFeaturedImage(id) {
    var activeImage = this.container.querySelector(selectors.visibleImageWrapper);
    var inactiveImage = this.container.querySelector(selectors.imageWrapperById(id));

    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  },
  updateBrowserHistory: function updateBrowserHistory(variant) {
    var enableHistoryState = this.productForm.element.dataset.enableHistoryState;

    if (!variant || enableHistoryState !== 'true') {
      return;
    }

    var url = (0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }
});